import {
  boolean,
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  CUSTOMER_CONTRACTS_SORT_KEYS
} from '@/features/shared/models'
import { TARIFF_TYPE } from '@/libs/api/types'

export const CustomerContractsSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(CUSTOMER_CONTRACTS_SORT_KEYS),
  dcId: optional(number()),
  name: optional(string()), // 契約名
  customerId: optional(number()), // 荷主
  tariffType: optional(enum_(TARIFF_TYPE)), // タリフ種別
  tariffKeyword: optional(string()), // タリフ名、コード
  isApplying: optional(boolean()), // 適用期間
  operatingDate: optional(string()) // 適用日
})

export type CustomerContractsSearch = InferOutput<
  typeof CustomerContractsSearchSchema
>
